import html2canvas from 'html2canvas';

export const downloadCard = async (component, filename) => {
  const canvas = await html2canvas(component, {
    useCORS: true,
    backgroundColor: null
  });
  const data = canvas.toDataURL('image/png');
  const link = document.createElement('a');
  link.href = data;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
